import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/catch';
import { of } from 'rxjs/observable/of';
import { from } from 'rxjs/observable/from';

import { type ActionsObservable } from 'redux-observable';

import { fetchFailed, fetchSuccess } from '../../common/fetch-request-analytics';
import { putProjectSpaceLink, setFirstSpaceCreatedFlag } from '../actions';
import {
	CREATE_CONFLUENCE_SPACE,
	createConfluenceSpaceError,
} from '../actions/create-confluence-space';
import { getAvailableSpaces } from '../confluence/spaces/selectors';
import { getSuggestedKey } from '../context/selectors';
import { getProjectId, getProjectKey, getProjectName, getProjectType } from '../project/selectors';
import { getUserEnteredSpaceName } from '../ui/create-space/selectors';
import { getProjectPageLinkedId, getProjectSpaceId } from '../confluence/connected-space/selectors';

import { requestCreateConfluenceSpace$ } from './requests';

export default (action$: ActionsObservable<any>, store: any) =>
	action$.ofType(CREATE_CONFLUENCE_SPACE).switchMap(({ autoCreated = false }) => {
		const state = store.getState();
		const availableSpaces = getAvailableSpaces(state);
		const userEnteredSpaceName: string = getUserEnteredSpaceName(state);
		const connectedPageId = getProjectPageLinkedId(state);
		const connectedSpaceId = getProjectSpaceId(state);
		const confluenceSpaceKey: string | null | undefined = getSuggestedKey(state);
		const projectName: string = getProjectName(state);
		const projectKey: string = getProjectKey(state);
		const projectId: number = getProjectId(state);
		const projectType: string = getProjectType(state);

		const confluenceSpaceName = autoCreated ? projectName : userEnteredSpaceName;

		if (
			confluenceSpaceKey === null ||
			confluenceSpaceKey === undefined ||
			confluenceSpaceKey === ''
		) {
			return of(createConfluenceSpaceError());
		}

		return requestCreateConfluenceSpace$(
			confluenceSpaceName,
			confluenceSpaceKey,
			projectKey,
			projectId,
			projectType,
		)
			.switchMap(({ spaceKey, spaceUrl, spaceId }) => {
				fetchSuccess('confluence.space.create', { autoCreated });
				return from([
					putProjectSpaceLink({
						spaceId,
						spaceKey,
						spaceUrl,
						projectKey,
						projectId,
						autoCreated,
						connectedPageId,
						connectedSpaceId,
					}),
					...(availableSpaces.length === 0 ? [setFirstSpaceCreatedFlag()] : []),
				]);
			})
			.catch((err) => {
				fetchFailed('confluence.space.create', err, { autoCreated });
				return of(createConfluenceSpaceError());
			});
	});
